export const SET_MODEL = 'SET_MODEL';
export const RESET_PHONES = 'RESET_PHONES';
export const SET_QUESTIONS = 'SET_QUESTIONS';
export const RESET_QUESTINS = 'RESET_QUESTINS';
export const ADD_ANSWER = 'ADD_ANSWER';
export const SET_PRICE = 'SET_PRICE';
export const SET_GRADE = 'SET_GRADE';
export const SET_REFUSALS = 'SET_REFUSALS';
export const SET_NUMBER = 'SET_NUMBER';
export const SET_LOADING = 'SET_LOADING';
export const SET_CALCULATION = 'SET_CALCULATION';
export const SET_ERROR = 'SET_ERROR';
export const SET_ERROR_SEARCH = 'SET_ERROR_SEARCH';
export const CHANGE_SCREEN_THREE = 'CHANGE_SCREEN_THREE';
export const CHANGE_CLIENT_INFO = 'CHANGE_CLIENT_INFO';
export const SET_ORDER = 'SET_ORDER';
export const SET_DISCOUNTS = 'SET_DISCOUNTS';
export const CLEAR_DISCOUNT = 'CLEAR_DISCOUNT';
export const SELECT_DISCOUNT = 'SELECT_DISCOUNT';
